
/// Global functions required by the DisplayTexts
/// *********************************************
/// DisplayTexts are HTML fragments stored in the database and rendered with v-html.
/// Some of them carry inline handlers, e.g.:
///
///   <a class="mobDTLink" onclick="NavigateToAnyURL('https://...', '_blank');">Depositor Information Sheet</a>
///
/// Inline handlers are evaluated in the GLOBAL scope, so they cannot reach Vue methods,
/// mixins or app.config.globalProperties. They must exist on "window".
///
/// These texts were originally written for the mobile app, where the functions are provided
/// by the Cordova shell (InAppBrowser, ShowWait, MessageBox, ...). None of that exists here,
/// so this module registers browser equivalents with the same signatures.
///
/// Registered from main.js, before the app is mounted.

/// Forces https and returns a safe, absolute url, or null when there is nothing to open
/// Also neutralises any non http(s) scheme (e.g. "javascript:") by prefixing it
/// **************************************************************************************
const _safeUrl = function (url) {
  const value = url == null ? '' : String(url).trim();
  if (!value) return null;    // Not configured for this credit union

  const absolute = value.substring(0, 7) !== 'http://' && value.substring(0, 8) !== 'https://' ? 'https://'.concat(value) : value;
  const finalUrl = absolute.replace('http://', 'https://');

  return finalUrl.length > 'https://'.length ? finalUrl : null;    // "https://" on its own is not a valid target
};

/// Registers the global functions, without overwriting an existing implementation
/// (if the module is ever hosted inside the mobile app, the Cordova version wins)
/// ******************************************************************************
const registerDisplayTextGlobals = function () {
  if (typeof window === 'undefined') return;

  /// Navigates to an URL
  /// Web counterpart of the mobile app function: there is no InAppBrowser here, so the
  /// mobile only arguments (showLocationBar / withNoEvents) are accepted and ignored.
  /// ***********************************************************************************
  if (!window.NavigateToAnyURL) {
    window.NavigateToAnyURL = function (URLToNavigate, targetMethod) {
      // The url is part of the DisplayText and is configured per credit union, so it can be
      // empty or blank. On those cases there is nothing to open and the click is ignored.
      const url = _safeUrl(URLToNavigate);
      if (!url) return null;

      try {
        return window.open(url, targetMethod || '_blank', 'noopener,noreferrer');
      }
      catch (error) {
        // Inline handlers have no error boundary: a bad url must never break the page
        console.error('NavigateToAnyURL: unable to open '.concat(url), error);
        return null;
      }
    };
  }

  /// Closes the mobile in-app browser: nothing to close in a regular browser
  /// **********************************************************************
  if (!window.CloseInAppBrowserMobile) {
    window.CloseInAppBrowserMobile = function () { };
  }
};

export default {
  registerDisplayTextGlobals
};
